const useQueryKey = (keyBase: string, deps: (string | undefined | null)[]) => `${keyBase}${deps.join('')}`;

export default useQueryKey;
